export const getKeyFromRpcUrl = (rpcUrl) => {
    if (!rpcUrl.includes('alchemyapi.io') && !rpcUrl.includes('alchemy.com')) {
        return rpcUrl;
    }
    const [key] = rpcUrl.split('/').reverse();
    return key;
};
